import { render } from "./categoryIndex.vue?vue&type=template&id=b0b071de"
import script from "./categoryIndex.vue?vue&type=script&lang=js"
export * from "./categoryIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__